import(/* webpackMode: "eager" */ "/vercel/path0/app/companies/page.tsx");
